import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    color: '#7F8487',
    fontSize: theme.size.sm,
    cursor: 'default'
  }
}))

export default useStyles
